export const GET_LOCATION_TRACKING_THRU_UID = "V3_GET_LOCATION_TRACKING_THRU_UID";
export const GET_BATCH_LOCATION_TRACKING = "V3_GET_BATCH_LOCATION_TRACKING";
export const CREATE_LOCATION_TRACKING = 'V3_CREATE_LOCATION_TRACKING'
export const UPDATE_LOCATION_TRACKING = 'V3_UPDATE_LOCATION_TRACKING'
export const GET_BATCH_COORDINATE_ADDRESS = 'V3_GET_BATCH_COORDINATE_ADDRESS'
